import React from "react";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "../../lib/site-data";
import LogoPlaceholder from "./LogoPlaceholder";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0F1A3A] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-1">
            <LogoPlaceholder variant="dark" testid="footer-logo-placeholder" />
            <p className="mt-5 text-sm text-white/60 leading-relaxed">
              Plumbing Done Right. Taylor Made For You. Locally owned and operated in {COMPANY.location}.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { Icon: Facebook, label: "Facebook", href: "https://www.facebook.com/share/1Bs2sHrjCt/?mibextid=wwXIfr" },
                { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/taylormadeps_001" },
              ].map(({ Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="h-10 w-10 rounded-lg bg-white/5 hover:bg-[#2563EB] flex items-center justify-center transition-colors"
                >
                  <Icon className="h-4 w-4 text-white" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="font-display font-bold text-white text-sm uppercase tracking-[0.15em]">
              Quick Links
            </div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-display font-bold text-white text-sm uppercase tracking-[0.15em]">
              Services
            </div>
            <ul className="mt-5 space-y-3">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.title}>
                  <a
                    href="#services"
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-display font-bold text-white text-sm uppercase tracking-[0.15em]">
              Contact
            </div>
            <ul className="mt-5 space-y-4">
              <li>
                <a
                  href={COMPANY.phoneLink}
                  data-testid="footer-phone"
                  className="flex items-start gap-3 text-sm text-white/80 hover:text-white"
                >
                  <Phone className="h-4 w-4 mt-0.5 text-[#FBBF24]" />
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a
                  href={COMPANY.emailLink}
                  data-testid="footer-email"
                  className="flex items-start gap-3 text-sm text-white/80 hover:text-white break-all"
                >
                  <Mail className="h-4 w-4 mt-0.5 text-[#FBBF24] shrink-0" />
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-white/80">
                <MapPin className="h-4 w-4 mt-0.5 text-[#FBBF24]" />
                {COMPANY.location}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50" data-testid="footer-copyright">
            © {year} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-white/40">
            Owner: {COMPANY.owner} · Conway, Arkansas
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
